import React from "react";
import { MainItemSelector } from "./MainItemSelector";
export var ItemGroupSection = function (_a) {
    var title = _a.title, items = _a.items, selectedIndex = _a.selectedIndex, onSelect = _a.onSelect;
    return (items.length <= 1 ? null : (React.createElement("section", { className: "item-customization-section" },
        React.createElement("div", { className: "item-customization-section-header" },
            React.createElement("h3", { className: "item-customization-section-title" }, title)),
        React.createElement(MainItemSelector, { items: items, selectedIndex: selectedIndex, onSelect: onSelect }))));
};
